const storageKey = "merrin.token"

let remembered: string | null = null

export function readToken(): string | null {
  try {
    return window.localStorage.getItem(storageKey) ?? remembered
  } catch {
    return remembered
  }
}

export function saveToken(token: string): void {
  remembered = token
  try {
    window.localStorage.setItem(storageKey, token)
  } catch {
    return
  }
}

export function clearToken(): void {
  remembered = null
  try {
    window.localStorage.removeItem(storageKey)
  } catch {
    return
  }
}
